import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './RestaurantsListingSearch.css';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { ReactComponent as SearchIcon } from "../../../../resources/icons/search-v1.svg";
import { ReactComponent as ClearIcon } from "../../../../resources/icons/close.svg";
import { addQueryString, deleteQueryString } from '../../../Listing';
import { tealiumClickFunc, tealiumMergeClickData } from '../../../../utils/tealium';
import { TEXT_SEARCH_FACET_NAME } from '../../RestaurantsListing';
var commonStyles = "c1yjx1yn";
var ltrStyles = "l1s0jgs4";
var rtlStyles = "r1dk43b0";
var RestaurantsListingSearch = function RestaurantsListingSearch(_ref) {
  var rtl = _ref.rtl,
    searchValue = _ref.searchValue,
    setSearchValue = _ref.setSearchValue,
    placeholder = _ref.placeholder,
    setListingFilter = _ref.setListingFilter,
    eventsAnalytics = _ref.eventsAnalytics,
    params = _ref.params;
  var history = useHistory();
  var _useState = useState(searchValue),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  var handleTextInput = function handleTextInput(e) {
    var target = e.target;
    setValue(target.value);
  };
  var handleCloseClick = function handleCloseClick() {
    setValue('');
    if (searchValue) {
      setSearchValue('');
      deleteQueryString(TEXT_SEARCH_FACET_NAME, history);
      setListingFilter();
    }
  };
  var handleKeyPress = function handleKeyPress(event) {
    if ((event.key === 'Enter' || event.key === 'NumpadEnter') && value.trim() !== searchValue.trim()) {
      sendRequestHandler(value);
      tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['searchInputClickAnalytics'], params), value);
    }
  };
  var handleGoClick = function handleGoClick() {
    sendRequestHandler(value);
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['searchInputClickAnalytics'], params), value);
  };
  var sendRequestHandler = function sendRequestHandler(title) {
    setValue(title);
    setSearchValue(title);
    addQueryString(TEXT_SEARCH_FACET_NAME, title, history);
    setListingFilter();
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles)
  }, /*#__PURE__*/React.createElement("div", {
    className: "input-search-box"
  }, /*#__PURE__*/React.createElement("input", {
    type: "text",
    className: "input-text-primary input-search-text",
    placeholder: placeholder,
    onKeyPress: handleKeyPress,
    onChange: handleTextInput,
    value: value
  }), /*#__PURE__*/React.createElement("button", {
    disabled: !value.trim().length,
    onClick: handleGoClick,
    className: "btn-link search-icon"
  }, /*#__PURE__*/React.createElement(SearchIcon, null)), !!value.trim().length && /*#__PURE__*/React.createElement("button", {
    onClick: handleCloseClick,
    className: "btn-link close-icon"
  }, /*#__PURE__*/React.createElement(ClearIcon, null))));
};
export default RestaurantsListingSearch;